import {
  UPDATE_PASSWORD_PENDING,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAIL,
  CLEAR_PASSWORD_ERROR,
} from '../actions/index'

const initialState = {
  success: false,
  error: '',
  loading: false,
}

export default function updatePassword(state = initialState, action) {
  switch (action.type) {
    case UPDATE_PASSWORD_PENDING: {
      return {
        ...state,
        success: null,
        error: null,
        loading: true,
      }
    }

    case UPDATE_PASSWORD_SUCCESS: {
      return {
        ...state,
        success: action.payload.success,
        error: null,
        loading: false,
      }
    }

    case UPDATE_PASSWORD_FAIL: {
      return {
        ...state,
        success: false,
        error: action.payload,
        loading: false,
      }
    }

    case CLEAR_PASSWORD_ERROR: {
      return {
        ...state,
        success: false,
        error: '',
        loading: false,
      }
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/update-password.js